import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { apiWrapper } from "../apis/CommonApi";
import * as mainApi from "../apis/MainApi";
import * as accountApi from "../apis/AccountApi";
import {
  setTokenInLocal,
  setTokenInSession,
  useAppContext,
} from "../utils/store";
import useInterval from "../utils/useInterval";

export default function LoginPage() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState(null);
  const { store, dispatch } = useAppContext();
  const [currentIndex, setCurrentIndex] = useState(0);
  const [dataSource, setDataSource] = useState([]);

  useEffect(() => {
    setFormDataProperty("userId", "");
    setFormDataProperty("password", "");

    apiWrapper(async () => {
      const result = await mainApi.getNoticePostList();
      const { status, data } = result;
      if (status === true) {
        setDataSource(data);
      }
    });
  }, []);

  useInterval(() => {
    if (dataSource) {
      setCurrentIndex((prevIndex) => {
        return (prevIndex + 1) % dataSource.length;
      });
    }
  }, 5000);

  const onChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    setFormDataProperty(name, value);
  };

  const setFormDataProperty = (name, value) => {
    setFormData((currentFormData) => {
      const nextFormData = {
        ...currentFormData,
        [name]: value,
      };
      //console.log(nextFormData);
      return nextFormData;
    });
  };

  const handleLogin = (e) => {
    e.preventDefault();

    apiWrapper(async () => {
      const form = e.currentTarget;
      if (form.checkValidity() === false) {
        e.stopPropagation();
      } else {
        apiWrapper(async () => {
          const requestBody = {
            userId: formData.userId,
            password: formData.password,
          };

          const { status, data } = await accountApi.login(requestBody);
          if (status === false) {
            alert(`${data}`);
          } else {
            const { refresh, access, user } = data;
            const { userId } = formData;
            //무조건 자동로그인
            //자동로그인일 때는 로컬스토리지에 저장
            dispatch(
              setTokenInLocal(
                access,
                refresh,
                user.id,
                userId,
                user.userName,
                user.userAuthority,
                completedCallback
              )
            );
          }
        });
      }
    });
  };

  const completedCallback = () => {
    navigate("/");
  };

  const handleNotice = () => {
    navigate("/notice/");
  };

  return (
    <section class="mbSection" style={{ display: 'flex', flexDirection: 'column' }}>
      <div class="container">
        <h2>화재경보시스템</h2>
        <div
          class="logo-wrap"
          style={{ height: "48px", backgroundColor: "#f5f5f5" }}
        ></div>
        {formData && (
          <form onSubmit={handleLogin}>
            <div class="input-wrap input-login-wrap">
              <div class="input-item">
                <p class="title-item">아이디</p>
                <input
                  type="text"
                  class="loginInput"
                  placeholder="아이디를 입력해주세요."
                  name="userId"
                  value={formData.userId}
                  onChange={onChange}
                  required
                />
              </div>
              <div class="input-item">
                <p class="title-item">비밀번호</p>
                <input
                  type="password"
                  class="loginInput"
                  placeholder="비밀번호를 입력해주세요."
                  name="password"
                  value={formData.password}
                  onChange={onChange}
                  required
                />
              </div>
            </div>
            <div class="find-btn-wrap">
              <Link to="/find-id-password/" class="link-btn">
                아이디 / 패스워드 찾기
              </Link>
            </div>
            <button type="submit" class="btn login-btn">
              로그인
            </button>
            <Link to="/join/" class="btn join-btn">
              회원가입
            </Link>
          </form>
        )}
      </div>
      <div style={{ marginTop: 'auto' }}>
        <div class="notice-box" onClick={handleNotice}>
          {dataSource[currentIndex] && (
            <p class="notice-title">{`[공지] ${dataSource[currentIndex].title}`}</p>
          )}
          <i class="x-icon title-icon"></i>
        </div>
        <div class="btm-wrap">
          <div class="nav-box" style={{ display: 'none' }}>
            <Link class="nav-item nav-sistem" to="">
              <p class="nav-title">
                시스템 소개 <br />
                (사용 메뉴얼)
              </p>
              <div class="nav-btn">
                <i class="x-icon"></i>
              </div>
            </Link>
            <Link class="nav-item nav-inquir" to="">
              <p class="nav-title">게시판 문의</p>
              <div class="nav-btn">
                <i class="x-icon"></i>
              </div>
            </Link>
          </div>
          <p class="copyright-txt">
            COPYRIGHT ALL RESERVED RMTECHSOLUTION.CO.,LTD.
          </p>
        </div>
      </div>
    </section>
  );
}
